import { render, staticRenderFns } from "./getMermaid.vue?vue&type=template&id=28edc506&scoped=true&"
import script from "./getMermaid.vue?vue&type=script&lang=js&"
export * from "./getMermaid.vue?vue&type=script&lang=js&"
import style0 from "./getMermaid.vue?vue&type=style&index=0&id=28edc506&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28edc506",
  null
  
)

export default component.exports